<template>
  <div
    id="scrollingBox"
    style="background-color:white;position:relative"
    v-show="!loaded"
    :style="{ 'pointer-events': !gesture ? 'auto' : 'none' }"
  >
    <img :src="isamnet" width="100%" @load="onLoad" />
    <div
      class="wrapper"
      :style="
        creative.offset_bottom_number
          ? `bottom:${creative.offset_bottom_number}${
              creative.offset_bottom_unit
            }`
          : ``
      "
    >
      <a class="closebutton" @click="close()"></a>
      <div class="outer">
        <div class="flipcard">
          <div class="card">
            <a
              :href="creative.scrolling_boxes[front_index].landing_page"
              target="_blank"
            >
              <img :src="creative.scrolling_boxes[front_index].image_url" />
            </a>
          </div>
          <div class="card back">
            <a
              :href="creative.scrolling_boxes[back_index].landing_page"
              target="_blank"
            >
              <img :src="creative.scrolling_boxes[back_index].image_url" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixPreview from "@/components/mixins/preview.js";
import mixMobile from "@/components/mixins/mobile.js";
export default {
  data() {
    return {
      loaded: 1,
      index: 0,
      front_index: 0,
      back_index: 1,
      is_front: true,
      degree: 0,
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if (domain === "prism.amnet.tw") {
        isAmnet += "/amnet/scrollingBox-bg.png";
      } else {
        isAmnet += "/scrollingBox/bg.png";
      }
      return isAmnet;
    },
  },
  async mounted() {
    this.viewport();
    await this.$nextTick();
    this.intervalEvent = setInterval(this.flip, 3000);
    this.up = () => this.handleGesture("up");
    this.down = () => this.handleGesture("down");
    const wrapper = document.querySelector(".wrapper");
    this.handleTouch(wrapper);
    this.handleAnimate(wrapper);
  },
  mixins: [mixPreview, mixMobile],
  methods: {
    handleGesture(gesture) {
      if (this.isAnimating) return;
      gesture === "up" ? this.flip() : this.invert_flip();
      clearInterval(this.intervalEvent);
      this.intervalEvent = setInterval(this.flip, 3000);
    },
    flip() {
      const len = this.creative.scrolling_boxes.length;
      const next_index = (this.index + 1) % len;
      if (this.is_front) {
        this.back_index = next_index;
      } else {
        this.front_index = next_index;
      }
      this.is_front = !this.is_front;
      this.degree += 180;
      const flipcard = document.querySelector(".flipcard");
      flipcard.style.transform = "rotateX(" + this.degree + "deg)";
      flipcard.style.WebkitTransform = "rotateX(" + this.degree + "deg)";
      flipcard.style.MozTransform = "rotateX(" + this.degree + "deg)";
      flipcard.style.OTransform = "rotateX(" + this.degree + "deg)";
      flipcard.style.msTransform = "rotateX(" + this.degree + "deg)";
      this.index = next_index;
    },
    invert_flip() {
      const len = this.creative.scrolling_boxes.length;
      const next_index = (len + this.index - 1) % len;
      if (this.is_front) {
        this.back_index = next_index;
      } else {
        this.front_index = next_index;
      }
      this.is_front = !this.is_front;
      this.degree -= 180;
      const flipcard = document.querySelector(".flipcard");
      flipcard.style.transform = "rotateX(" + this.degree + "deg)";
      flipcard.style.WebkitTransform = "rotateX(" + this.degree + "deg)";
      flipcard.style.MozTransform = "rotateX(" + this.degree + "deg)";
      flipcard.style.OTransform = "rotateX(" + this.degree + "deg)";
      flipcard.style.msTransform = "rotateX(" + this.degree + "deg)";
      this.index = next_index;
    },
  },
};
</script>

<style lang="sass" scoped>
.wrapper
  width: 100%
  height: 80px
  position: fixed
  bottom: 0px
  left: 0px
  .closebutton
    cursor: pointer
    position: absolute
    display: block
    width: 32px
    height: 32px
    background-color: white
    background-position: 0 0
    background-image: url('https://cdn.aralego.net/rich_media/assets/close_btn.png')
    z-index: 50000
    top: -15px
    right: 5px
    background-size: contain
    border-radius: 16px
  .outer
    width: 100%
    height: 100%
    -webkit-perspective: 1500
    -moz-perspective: 1500
    -ms-perspective: 1500
    perspective: 1500
    .flipcard
      position: relative
      height: 80px
      width: 100%
      -webkit-transform-style: preserve-3d
      -webkit-transition: 0.8s
      -moz-transform-style: preserve-3d
      -moz-transition: 0.8s
      -ms-transform-style: preserve-3d
      -ms-transition: 0.8s
      transform-style: preserve-3d
      transition: transform 0.8s
      .card
        position: absolute
        left: 0
        right: 0
        background-color: transparent
        height: 100%
        -webkit-backface-visibility: hidden
        -moz-backface-visibility: hidden
        -ms-backface-visibility: hidden
        backface-visibility: hidden
        &>a
          display: -webkit-box
          display: -moz-box
          display: -ms-flexbox
          display: -webkit-flex
          display: flex
          justify-content: center
          height: 100%
          &>img
            height: 100%
            display: block
            margin: 0 auto
      .back
        -webkit-transform: rotateX(180deg)
        transform: rotateX(180deg)
        -moz-transform: rotateX(180deg)
        -ms-transform: rotateX(180deg)
</style>
